import React from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from 'jbc-front/components/Form';
import EmployeeAndSalarySetting from './EmployeeAndSalarySetting';
import ProcedureList from './ProcedureList';
import BonusPaymentNotificationList from './BonusPaymentNotificationList';
import styles from './TodoList.scss';

const TodoList = ({ mostRecentNotConfirmedSalary }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className='u-mt30'>
      <Section title={t('features.Dashbord.components.TodoList.To_do_list')} className={styles.section}>
        <EmployeeAndSalarySetting mostRecentNotConfirmedSalary={mostRecentNotConfirmedSalary} />
        <ProcedureList />
        <BonusPaymentNotificationList />
      </Section>
    </div>
  );
};

export default TodoList;
